import {
  Button,
  Card,
  Grid,
  List,
  Modal,
  Toast,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";
import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import instance from "../../../../util/axios";
import { Result } from "../../../../schema";
import DictionarySelect from "../../../../component/CheckBoxItem";

export default function ManagerReject(): JSX.Element {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [data, setData] = useState<ProductionTaskRejectStatItemDTO[]>([]);
  const [submitForm, setSubmitForm] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });

  const load = useCallback(() => {
    instance
      .get<Result<ProductionTaskRejectStatItemDTO[]>>(
        `/erp/production-tasks/rejectList`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setData(resp.data.Data);
        } else {
          Toast.fail(resp.data.Message);
        }
      });
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      {data.map((item) => (
        <WingBlank size="lg">
          <WhiteSpace size="lg" />
          <Card>
            <Card.Header title={item.orderNumber} />
            <Card.Body>
              <Grid
                square={false}
                hasLine={false}
                itemStyle={GridStyle}
                data={[
                  {
                    text: item.orderNumber,
                  },
                  {
                    text: item.radName,
                  },
                  {
                    text: item.model,
                  },
                  {
                    text: item.colorName,
                  },
                  {
                    text: item.caliberName,
                  },
                  {
                    text: item.workshopName,
                  },
                  {
                    text: item.procedureName,
                  },
                  {
                    text: "抽检数量：" + item.totalCount,
                  },
                  {
                    text: "不良数量：" + item.count,
                  },
                  {
                    text: "巡检人员:" + item.creatorName,
                  },

                  {
                    text: "原因描述：" + item.remark,
                  },
                ]}
                columnNum={2}
              />
            </Card.Body>
            <Card.Footer
              content={
                <>
                  <table style={{ width: "100%" }}>
                    <tr>
                      <td>
                        <Button
                          icon="check-circle-o"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSubmitForm({
                              visible: true,
                              rejectId: item.uuid,
                              userId: "",
                            });
                          }}
                        >
                          确认生产员工
                        </Button>
                      </td>
                    </tr>
                  </table>
                </>
              }
            />
          </Card>
          <WhiteSpace size="lg" />
        </WingBlank>
      ))}
      <Modal
        title={"打回给生产员工"}
        visible={submitForm.visible}
        onClose={() =>
          setSubmitForm({
            visible: false,
          })
        }
        transparent
        maskClosable={false}
        closable={true}
        footer={[
          {
            text: "确定",
            onPress: async () => {
              if (!submitForm.userId) {
                Toast.fail(`请选择要打回的生产员工`);
                return;
              }

              const resp = await instance.post<Result<string>>(
                `/erp/production-tasks/reject`,
                {
                  rejectId: submitForm.rejectId,
                  userId: submitForm.userId,
                }
              );
              if (resp.data.Status === "1") {
                Toast.success(`操作成功！`);
              } else {
                Toast.fail(resp.data.Data);
              }
              setSubmitForm({
                visible: false,
              });
              load();
            },
          },
        ]}
      >
        <List>
          <DictionarySelect
            title={"生产员工："}
            multiple={false}
            dictionary={"base_staff"}
            value={submitForm.userId}
            onChange={(value) => {
              setSubmitForm((prevState) => ({
                ...prevState,
                userId: value,
              }));
            }}
          />
        </List>
      </Modal>
    </>
  );
}
